/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineDot from '@mui/lab/TimelineDot';
import { CheckMarkIcon, BackArrowIcon } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function HorizontalTimeline({ activeStep, steps }) {
  const classes = useStyles();

  return (
    <Timeline data-testid="horizontal-timeline" classes={{ root: classes.timeline }}>
      {steps.map((id) => (
        <TimelineItem data-testid="horizontal-timeline-item" classes={{ root: classes.timelineItem }} key={id}>
          <TimelineSeparator>
            <TimelineDot
              sx={{ backgroundColor: id > activeStep ? 'white' : '' }}
              classes={{ root: classes.timelineDot }}
              color="primary"
              variant={id <= activeStep ? 'filled' : 'outlined'}
            >
              {id < activeStep && <CheckMarkIcon classes={classes.checkMarkIcon} />}
            </TimelineDot>
          </TimelineSeparator>
        </TimelineItem>
      ))}
    </Timeline>
  );
}

HorizontalTimeline.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default HorizontalTimeline;
